import {names} from "../../common";

export const sortItems = [
  { value: "Сначала новые", name: names.sortDescDate },
  { value: "Сначала старые", name: names.sortAscDate },
  { value: "Сначала дешёвые", name: names.sortAscPrice },
  { value: "Сначала дорогие", name: names.sortDescPrice },
];